import React from 'react';
import { compose } from 'redux';
import { useSelector } from 'react-redux';
import T from 'prop-types';

import { useResolutionCheck } from 'web-components';
import { COLORS } from 'components/Graphs/multipleSensors/utils';

import { getData } from 'redux/rootSelectors';
import { getSelectedMachineSensorComparisonSensorData } from 'redux/machines/selectors';
import withLoadingState from 'helpers/withLoadingState';
import MultipleSensorsBrush from 'components/Graphs/multipleSensors/MultipleSensorsBrush';
import { useSensorComparisonConfig } from '../sensorComparisonBlock.hooks';

import { BrushWrapper, GraphWrapper, StyledEmptyState } from './SensorComparisonGraph.styled';
import BatchMultipleSensorsGraph from './MultipleSensorsGraph';
import { getSelectedBatchRecord } from '../../../../redux/batch/selectors';

const BatchSensorComparisonGraph = ({ selectedSensors, selectedSensorTypes }) => {
  const { isMobile } = useResolutionCheck();
  const { machineId } = useSensorComparisonConfig();
  const data = useSelector(compose(getData, getSelectedMachineSensorComparisonSensorData));
  const batch = useSelector(getSelectedBatchRecord);
  const hasData = (data.sensors || []).length > 0;

  if (!hasData) {
    return <StyledEmptyState type="sensorHistoricalData" />;
  }

  const getGraphLineColor = sensorType => {
    const colorIndex = selectedSensorTypes.indexOf(sensorType);
    return COLORS[colorIndex];
  };

  return (
    <>
      <GraphWrapper mobile={isMobile}>
        <BatchMultipleSensorsGraph
          selectedSensorTypes={selectedSensorTypes}
          selectedSensors={selectedSensors}
          getGraphLineColor={getGraphLineColor}
        />
      </GraphWrapper>
      <BrushWrapper mobile={isMobile}>
        <MultipleSensorsBrush
          isBatchRecords
          batchId={batch.details.id}
          machineId={machineId}
          getGraphLineColor={getGraphLineColor}
        />
      </BrushWrapper>
    </>
  );
};

export default withLoadingState(BatchSensorComparisonGraph);

BatchSensorComparisonGraph.propTypes = {
  selectedSensorTypes: T.arrayOf(T.string).isRequired,
  selectedSensors: T.arrayOf(T.shape({})).isRequired
};
